export default "__VITE_ASSET__M9iKxrl0__"